import Raven from 'raven-js';

export const sentry_dsn = 'https://035551308270499bbd340298df24fab4@sentry.io/104849';

export function logException(ex, context) {
    Raven.captureException(ex, {
        extra: context
    });

    // eslint-disable-next-line
    window && window.console && console.error && console.error(ex);
}



/** WEBPACK FOOTER **
 ** ./src/sentry.js
 **/